import React from 'react';
import './TextArea.css';

import classNames from 'classnames';
import RcTextArea, { TextAreaProps, TextAreaRef } from 'rc-textarea';

type Props = TextAreaProps;

const TextArea = React.memo(
  React.forwardRef(({ className, ...rest }: Props, ref: React.Ref<TextAreaRef>) => {
    return <RcTextArea className={classNames('TextArea', className)} ref={ref} {...rest} />;
  }),
);

export default TextArea;
